import React from 'react';
import { Row, Col, Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import GetNewAppVersion from '../../../../static/appVersion/android/index.text'
import GetNewAppVersionXML from '../../../../static/appVersion/android/android_dashboard_show_new_version_dialog.text'
import iHealthSDKCheckVersionTool1 from '../../../../static/appVersion/ios/iHealthSDKCheckVersionTool1.text'
import iHealthSDKCheckVersionTool2 from '../../../../static/appVersion/ios/iHealthSDKCheckVersionTool2.text'

const InstructionPage = (props) => {
    const navigate = useNavigate();
    React.useEffect(() => {

    }, [])

    function downloadAndroid() {
        fetch(GetNewAppVersion)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'java'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "GetNewAppVersion.java");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

        fetch(GetNewAppVersionXML)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'xml'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "android_dashboard_show_new_version_dialog.xml");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

    }
    function downloadIOS() {
        fetch(iHealthSDKCheckVersionTool1)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'java'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "iHealthSDKCheckVersionTool.h");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

            fetch(iHealthSDKCheckVersionTool2)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'java'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "iHealthSDKCheckVersionTool.m");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

    }
    return (
        <Modal
            centered
            open={props.open}
            onCancel={(e) => { props.showModal() }}
            footer={null}
            width={1000}
            destroyOnClose={true}
            maskClosable={false}
            maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
            bodyStyle={{ padding: '0px', width: '1000px', height: '800px', background: 'ffffff', borderRadius: '10px' }} >
            <div style={{ width: '1000px', height: '800px', padding: '20px', borderRadius: "10px", overflow: "auto" }}>
                <div style={{ width: '1000px', }}>
                    <div style={Styles.title}> 1.创建新应用</div>
                    <div style={Styles.describe}> 点击“创建新应用”后依次填写以下内容完成创建</div>
                    <div style={Styles.describe}> 1.同一个系统并且同包名（Android：applicationId，iOS：BundleID）可以创建多个不同app名称的项目，例如包名“com.ihealth.app”，可使用app名称： ihealth1，ihealth2，ihealth3，ihealthN等</div>
                    <div style={Styles.describe}> 2.只有创建应用人员可以删除应用</div>
                    <div style={Styles.describe}> 3.可编辑人员可对app历史版本进行上传、删除和修改备注操作，创建应用人员可以批量增删编辑人员</div>
                    <div style={Styles.describe}> 4.创建应用人员可以编写应用描述，使其他人员了解该应用</div>
                    <div style={Styles.describe}> 5.点击upLoadApp可选择上传的应用包</div>
                    <div style={Styles.describe}> 完成以上操作后便可点击“创建”上传新应用</div>

                    <div style={Styles.title}> 2.首页 可通过选择iOS、Android筛选应用系统列表</div>

                    <div style={Styles.title}> 3.应用详情页</div>
                    <div style={Styles.describe}> 1.可点击“上传新版本”上传新app</div>
                    <div style={Styles.describe2}>注意事项：同版本上传会被覆盖，且只可以上传该项目的app</div>
                    <div style={Styles.describe}> 2.所有人员可查看项目基本信息，但是只有项目创建人员可以编辑基本信息</div>
                    <div style={Styles.describe}> 3.版本管理中的历史版本只有可编辑人员和owner有权限编辑和删除，其余人员只可以预览详情</div>
                    <div style={Styles.describe}> 4.权限控制，  可编辑人员和owner可以查看</div>
                    <div style={Styles.describe2}> 访问密码 ：需要设置密码后开启app详情页访问密码</div>
                    <div style={Styles.describe2}> 每天最高下载:可设置参数后开启限制每日所有历史版本总下载量</div>
                    <div style={Styles.describe2}> 可编辑人员:只有owenr人员可以增删可编辑人员</div>
                    <div style={Styles.describe2}> 以上选项需要在修改后点击保存生效</div>

                    <div style={Styles.title}> 4.历史版本app详情页</div>
                    <div style={Styles.describe}> 页面加载内容区分pc端和移动端，移动端只有正确的系统访问才可以下载，如Android包只可以在Android手机访问才可以下载,iOS包则只可以在iphone下载。</div>
                    <div style={Styles.describe2}> 若开启访问密码，则必须输入正确密码才可以正常访问</div>
                    <div style={Styles.describe2}> 历史版本app详情页可以不登录dashboard访问</div>

                    <div style={Styles.title}> 5.集成新版本检测，并通过外链更新</div>
                    <Row style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', }}>
                        <div style={Styles.describe}> Android模块,下载附件导入项目</div>
                        <Button className="btn" style={{ marginLeft: '10px', fontSize: '16px', padding: '0px', color: '#FF5300', border: 'none' }} 
                        onClick={() => downloadAndroid()} type="text">下载附件</Button>

                    </Row>

                    <div style={Styles.describe2}> 调用方式：GetNewAppVersion.check(getActivity(),"新应用名");</div>


                    <Row style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', }}>
                        <div style={Styles.describe}> iOS模块,下载附件导入项目</div>
                        <Button className="btn" style={{ marginLeft: '10px', fontSize: '16px', padding: '0px', color: '#FF5300', border: 'none' }} 
                        onClick={() => downloadIOS()} type="text">下载附件</Button>
                    </Row>
                    <div style={Styles.describe2}> {"调用方式：checkHaveNewVersion:(NSString*)新应用名"}</div>


                </div>
            </div>

        </Modal>

    );

}
const Styles = {
    title: {
        fontSize: '18px',
        color: 'rgba(0, 0, 0, 1)',
        marginTop: '15px'
    }, describe: {
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.55)',
        marginLeft: '20px'
    }, describe2: {
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.55)',
        marginLeft: '40px'
    },
}
export default InstructionPage